import React from "react";
import { Reveal, CTAButton, TrustBadges } from "./ui";
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-white to-[var(--calm-blue)]/60 px-4 py-12 sm:px-8 sm:py-28" data-id="element-77" data-mp="3ud6zpjgqgoct">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#e3f2e8] opacity-50 blur-3xl" data-id="element-78" data-mp="c83pjkbwtm5j" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-79" data-mp="m46sgsel5otj">
        <Reveal data-id="element-80" data-mp="h5vdk39foo4g">
          <h2 className="font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-81" data-mp="h6djxspt8iq3">
            Tu hijo no necesita padres perfectos. Necesita adultos que tengan
            herramientas.
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-82" data-mp="qwgmajitn913">
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-[var(--muted)] sm:mt-6 sm:text-lg" data-id="element-83" data-mp="14vfzmv0vw1hy">
            Cada día que pasa sin entender qué necesita realmente… es un día más
            de frustración para toda la familia. Hoy podés empezar a cambiar eso.
          </p>
        </Reveal>
        <Reveal delay={0.2} data-id="element-84" data-mp="2h3hocnypew5u">
          <p className="mt-8 text-sm font-bold uppercase tracking-[0.15em] text-[var(--accent)]" data-id="element-85" data-mp="2h4srclkbrzvw">
            Pequeños Pasos, Grandes Logros™
          </p>
          <div className="mt-3 space-y-1 font-serif-display text-xl text-[var(--ink)]" data-id="element-86" data-mp="2m56ym1e3r5sv">
            <p data-id="element-87" data-mp="2qzujlq9wdi2p">Menos incertidumbre.</p>
            <p data-id="element-88" data-mp="2v424tdh5cfw6">Más comprensión.</p>
            <p data-id="element-89" data-mp="2v2zgndb7krjy">Más tranquilidad.</p>
          </div>
        </Reveal>
        <Reveal delay={0.3} className="mt-7 sm:mt-10" data-id="element-90" data-mp="301tzgf96eg42">
          <CTAButton data-id="element-91" data-mp="300iy0m37dkg4">Quiero empezar hoy</CTAButton>
          <TrustBadges className="mt-6" data-id="element-92" data-mp="34udc9a01h77t" />
        </Reveal>
      </div>
    </section>;
}